
import { Telemetry, ValidTelemetryEvent } from '~commonInfra/services/Telemetry';

export const connectDisconnectEventType = 'site_slack_connection';
export const upgradeSlackConnectionEventType = 'site_slack_upgrade';
export const userReturnFromSlackEventType = 'user_return_from_slack';
export const commentingMentionNotificationType = 'commentingMention';
export const dataDrivenAlertNotificationType = 'dataDrivenAlert';
export const sharingNotificationType = 'sharing';
export const editAlertLinkType = 'editAlert';
export const viewLinkType = 'view';

export interface ConnectToSlackEvent extends ValidTelemetryEvent {
  type: string;
  user_id: string;
  site_luid: string;
  is_connect: boolean; // If value is true, this is a "Connect to Slack" event. If value is false, it is a "Disconnect from Slack" event
  version: string | null; // non-null if and only if type is site_slack_upgrade
}

export interface ReturnLinkFromSlackEvent extends ValidTelemetryEvent {
  type: string;
  user_id: string;
  site_luid: string;
  notification_type: string;
  link_type: string;
}

interface ConnectDisconnectSlackEventParams {
  userId: string;
  siteLuid: string;
  connectToSlack: boolean;
}

export function sendConnectToSlackTelemetry(params: ConnectDisconnectSlackEventParams) {
  Telemetry.sendEvent<ConnectToSlackEvent>({
    type: connectDisconnectEventType,
    user_id: params.userId,
    site_luid: params.siteLuid,
    is_connect: params.connectToSlack,
    version: null
  });
}

interface UpgradeSlackConnectionEventParams {
  userId: string;
  siteLuid: string;
  version: string;
}

export function sendUpgradeSlackConnectionTelemetry(params: UpgradeSlackConnectionEventParams) {
  Telemetry.sendEvent<ConnectToSlackEvent>({
    type: upgradeSlackConnectionEventType,
    user_id: params.userId,
    site_luid: params.siteLuid,
    is_connect: true,
    version: params.version,
  });
}

interface ReturnFromSlackEventParams {
  userId: string;
  siteLuid: string;
  notificationType: string;
  linkType: string;
}

export function sendReturnFromSlackTelemetry(params: ReturnFromSlackEventParams) {
  Telemetry.sendEvent<ReturnLinkFromSlackEvent>({
    type: userReturnFromSlackEventType,
    user_id: params.userId,
    site_luid: params.siteLuid,
    notification_type: params.notificationType,
    link_type: params.linkType,
  });
}